import { render, staticRenderFns } from "./ResetSuccess.vue?vue&type=template&id=aea96b3e"
import script from "./ResetSuccess.vue?vue&type=script&lang=js"
export * from "./ResetSuccess.vue?vue&type=script&lang=js"
import style0 from "./ResetSuccess.vue?vue&type=style&index=0&id=aea96b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports